interface IScreenSize {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
}
export const remBreakpoints: IScreenSize = {
    xs: 1,
    sm: 37.5,
    md: 45,
    lg: 52.5,
    xl: 79.5,
};

const remToPx = (rem: number) => {
    return rem * 16;
};

const breakpoints: IScreenSize = {
    xs: remToPx(remBreakpoints.xs),
    sm: remToPx(remBreakpoints.sm),
    md: remToPx(remBreakpoints.md),
    lg: remToPx(remBreakpoints.lg),
    xl: remToPx(remBreakpoints.xl),
};
const gridTheme: { breakpoints: IScreenSize} = { breakpoints };

const gridSize = () => {
    if (typeof window !== 'undefined') {
        return window.innerWidth;
    }
    return 0;
};
const currentGridSize = gridSize();
const isMobile = () => {
    if (currentGridSize !== 0) {
        return innerWidth < gridTheme.breakpoints.lg;
    }
    return false;
};
export default {
    remBreakpoints,
    remToPx,
    gridTheme,
    currentGridSize,
    isMobile,
};
